export const assetRegistry = {
  brand: {
    logoPrimary: '/assets/brand/logo-primary.svg',
    logoMark: '/assets/brand/logo-mark.svg',
    appIcon: '/assets/brand/app-icon.svg',
  },
  illustrations: {
    default: '/assets/illustrations/default.svg',
  },
} as const;

export type IllustrationName = keyof typeof assetRegistry.illustrations;
